import { Control, useController } from 'react-hook-form';

import { CarrierTermsFormValues } from './types';
import { isRequired } from '../../validators';

export const useControllers = (
  control: Control<CarrierTermsFormValues, any, CarrierTermsFormValues>
) => {
  const {
    field: { value: mnoIds, onChange: setMnoIds },
    fieldState: { error: mnoIdsError },
  } = useController({
    control,
    name: 'mnoIds',
    rules: {
      validate: {
        isRequired,
      },
    },
  });

  return {
    mnoIds,
    setMnoIds,
    mnoIdsError,
  };
};
